<div class="settings-group-page">
  <div class="settings-group-page__navigation">
    <div class="settings-group-page__navigation__wrapper">
      <div
        class="settings-group-page__navigation__wrapper--button"
        [routerLink]="'../'">
        <span class="dv-icons">arrow_back</span
        ><span class="settings-group-page__navigation__wrapper--button--text">{{
          'Settings.SettingsGroupPage.Back' | translate | uppercase
        }}</span>
      </div>
    </div>

    <div class="settings-group-page__navigation__menu">
      <dv-settings-menu
        [icon]="icon"
        title="{{ settingsMenuPageTitle | translate }}"
        [menuItems]="settingsMenuPageItems">
      </dv-settings-menu>
    </div>
  </div>
  <div class="settings-group-page__content">
    <router-outlet />
  </div>
</div>
